export enum PDF_STATE
{
    PENDING,
    ADDING
}